import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { captureConsole } from './logConsole';

// Initialize console error capture
captureConsole();

// Get the root container
const container = document.getElementById('root');
const root = createRoot(container);

// Render the app
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
